import {
    OPERATOR_BOOKING_LIST_START,
    OPERATOR_BOOKING_UPCOMING_LIST,
    OPERATOR_BOOKING_ONGOING_LIST,
    OPERATOR_BOOKING_COMPLETED_LIST,
    OPERATOR_BOOKING_CANCELLED_LIST,
    OPERATOR_BOOKING_LIST_ERROR,
    OPERATOR_BOOKING_START_TRIP_START,
    OPERATOR_BOOKING_START_TRIP_SUCCESS,
    OPERATOR_BOOKING_START_TRIP_ERROR,
    OPERATOR_BOOKING_DETAIL_START,
    OPERATOR_BOOKING_DETAIL_SUCCESS,
    OPERATOR_BOOKING_DETAIL_ERROR,
    OPERATOR_BOOKING_END_TRIP_START,
    OPERATOR_BOOKING_END_TRIP_SUCCESS,
    OPERATOR_BOOKING_END_TRIP_ERROR,
  } from "Constant";
  
  const initialState = {
    loading: false,
    upcoming_data: [],
    ongoing_data: [],
    completed_data: [],
    cancelled_data: [],
    start_trip_data: [],
    booking_details: [],
    end_trip_data: []
  };
  
  export default function operatorBookingListReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
        case OPERATOR_BOOKING_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case OPERATOR_BOOKING_UPCOMING_LIST:
            return {
                ...state,
                upcoming_data: action.payload,
                loading: false,
            };
        case OPERATOR_BOOKING_ONGOING_LIST:
            return {
                ...state,
                ongoing_data: action.payload,
                loading: false,
            };
        case OPERATOR_BOOKING_COMPLETED_LIST:
            return {
                ...state,
                completed_data: action.payload,
                loading: false,
            };
        case OPERATOR_BOOKING_CANCELLED_LIST:
            return {
                ...state,
                cancelled_data: action.payload,
                loading: false,
            }
        case OPERATOR_BOOKING_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case OPERATOR_BOOKING_START_TRIP_START:
            return {
                ...state,
                loading: true,
            };
        case OPERATOR_BOOKING_START_TRIP_SUCCESS:
            return {
                ...state,
                start_trip_data: action.payload,
                loading: false,
            };
        case OPERATOR_BOOKING_START_TRIP_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case OPERATOR_BOOKING_DETAIL_START:
            return {
                ...state,
                loading: true,
            };
        case OPERATOR_BOOKING_DETAIL_SUCCESS:
            return {
                ...state,
                booking_details: action.payload,
                loading: false,
            };
        case OPERATOR_BOOKING_DETAIL_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case OPERATOR_BOOKING_END_TRIP_START:
            return {
                ...state,
                loading: true,
            };
        case OPERATOR_BOOKING_END_TRIP_SUCCESS:
            return {
                ...state,
                end_trip_data: action.payload,
                loading: false,
            };
        case OPERATOR_BOOKING_END_TRIP_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
  }
  